<div
  class="layer-list-container"
  *ngIf="!(newRegisterMode || hasGraphicObj); else selectedGraphicTpl"
>
  <app-radio-group
    class="radio-group"
    [scrollable]="true"
    [items]="layerList"
    [(value)]="layerItemSelected"
    [showRadioButton]="false"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-radio-group>
</div>

<ng-template #selectedGraphicTpl>
  <app-button
    class="btn-go-back"
    buttonType="normal"
    styleType="text"
    shapeType="circle"
    marginType="icon"
    icon="assets/icons/chevron-left.svg"
    (click)="onBtnGoBackClick()"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-button>

  <div *ngIf="!!newRegisterMode && !hasGraphicObj" class="point-selection-step">
    <div class="title" [appBlockModalDrag]="!(isMobileModeObservable | async)">
      <span class="text" [appBlockModalDrag]="!(isMobileModeObservable | async)">
        SELECIONE UM PONTO NO MAPA
      </span>
    </div>

    <div class="icon-container">
      <app-iconic
        class="icon"
        icon="assets/icons/map-location-dot.svg"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-iconic>
    </div>

    <div class="category">
      <span class="text" [appBlockModalDrag]="!(isMobileModeObservable | async)">
        CATEGORIA: {{ layerItemSelected?.layer?.title }}</span
      >
    </div>
  </div>

  <div *ngIf="hasGraphicObj" class="form-container">
    <form
      *ngIf="!!formGroup"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit($event)"
      class="form"
    >
      <app-scroll-view class="scroll-view">
        <div class="fields-container">
          <div class="field-set" *ngIf="fieldExists('idobjeto')">
            <label label
              >{{ getFieldAlias("idobjeto")
              }}{{ isFieldRequired("idobjeto") ? "*" : "" }}</label
            >

            <app-input-box
              formControlName="idobjeto"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('distrito')">
            <label label
              >{{ getFieldAlias("distrito")
              }}{{ isFieldRequired("distrito") ? "*" : "" }}</label
            >

            <app-select-box
              formControlName="distrito"
              [items]="districtList"
              displayExpr="label"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('concelho')">
            <label label
              >{{ getFieldAlias("concelho")
              }}{{ isFieldRequired("concelho") ? "*" : "" }}</label
            >

            <app-select-box
              formControlName="concelho"
              [items]="countyList"
              displayExpr="label"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('freguesia')">
            <label label
              >{{ getFieldAlias("freguesia")
              }}{{ isFieldRequired("freguesia") ? "*" : "" }}</label
            >

            <app-select-box
              formControlName="freguesia"
              [items]="parishList"
              displayExpr="label"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('arruamento')">
            <label label
              >{{ getFieldAlias("arruamento")
              }}{{ isFieldRequired("arruamento") ? "*" : "" }}</label
            >

            <app-input-box
              formControlName="arruamento"
              [maxLength]="getMaxLength('arruamento')"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('npolicia')">
            <label label
              >{{ getFieldAlias("npolicia")
              }}{{ isFieldRequired("npolicia") ? "*" : "" }}</label
            >

            <app-input-box
              formControlName="npolicia"
              [maxLength]="getMaxLength('npolicia')"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('tracado')">
            <label label
              >{{ getFieldAlias("tracado")
              }}{{ isFieldRequired("tracado") ? "*" : "" }}</label
            >

            <app-select-box
              formControlName="tracado"
              [items]="getDomainList('tracado')"
              displayExpr="name"
              valueExpr="code"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('afetacaoprincipal')">
            <label label
              >{{ getFieldAlias("afetacaoprincipal")
              }}{{ isFieldRequired("afetacaoprincipal") ? "*" : "" }}</label
            >

            <app-select-box
              formControlName="afetacaoprincipal"
              [items]="getDomainList('afetacaoprincipal')"
              displayExpr="name"
              valueExpr="code"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('diametro')">
            <label label
              >{{ getFieldAlias("diametro")
              }}{{ isFieldRequired("diametro") ? "*" : "" }}</label
            >

            <app-input-box
              type="number"
              formControlName="diametro"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('comprimento')">
            <label label
              >{{ getFieldAlias("comprimento")
              }}{{ isFieldRequired("comprimento") ? "*" : "" }}</label
            >

            <app-input-box
              type="number"
              formControlName="comprimento"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('largura')">
            <label label
              >{{ getFieldAlias("largura")
              }}{{ isFieldRequired("largura") ? "*" : "" }}</label
            >

            <app-input-box
              type="number"
              formControlName="largura"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('altura')">
            <label label
              >{{ getFieldAlias("altura")
              }}{{ isFieldRequired("altura") ? "*" : "" }}</label
            >

            <app-input-box
              type="number"
              formControlName="altura"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('cota')">
            <label label
              >{{ getFieldAlias("cota")
              }}{{ isFieldRequired("cota") ? "*" : "" }}</label
            >

            <app-input-box
              type="number"
              formControlName="cota"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('tipoutilizacao')">
            <label label
              >{{ getFieldAlias("tipoutilizacao")
              }}{{ isFieldRequired("tipoutilizacao") ? "*" : "" }}</label
            >

            <app-type-utilization-box
              formControlName="tipoutilizacao"
              [readOnly]="isAllFieldsReadonly"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-type-utilization-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('estadooperacional')">
            <label label
              >{{ getFieldAlias("estadooperacional")
              }}{{ isFieldRequired("estadooperacional") ? "*" : "" }}</label
            >

            <app-select-box
              formControlName="estadooperacional"
              [items]="getDomainList('estadooperacional')"
              displayExpr="name"
              valueExpr="code"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('estadoocupacao')">
            <label label
              >{{ getFieldAlias("estadoocupacao")
              }}{{ isFieldRequired("estadoocupacao") ? "*" : "" }}</label
            >

            <app-input-box
              type="number"
              formControlName="estadoocupacao"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('baseinstalacao')">
            <label label
              >{{ getFieldAlias("baseinstalacao")
              }}{{ isFieldRequired("baseinstalacao") ? "*" : "" }}</label
            >

            <app-select-box
              formControlName="baseinstalacao"
              [items]="getDomainList('baseinstalacao')"
              displayExpr="name"
              valueExpr="code"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>

          <div class="field-set" *ngIf="fieldExists('cdt')">
            <label label
              >{{ getFieldAlias("cdt")
              }}{{ isFieldRequired("cdt") ? "*" : "" }}</label
            >

            <app-input-box
              formControlName="cdt"
              [maxLength]="getMaxLength('cdt')"
              [readOnly]="isAllFieldsReadonly"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>
        </div>
      </app-scroll-view>

      <div class="actions-container">
        <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
          <app-button
            type="submit"
            buttonType="primary"
            styleType="contained"
            text="Gravar"
            width="100%"
            [disabled]="isBtnSubmitDisabled"
          ></app-button>
        </div>

        <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
          <app-button
            buttonType="normal"
            styleType="contained"
            text="Limpar"
            width="100%"
            (click)="onBtnClearForm()"
            [disabled]="isAllFieldsReadonly"
          ></app-button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
